'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var getSessionInfo = require('./http-721ad2e6.js');
var history = require('./history-569c9f39.js');
var getHost = require('./getHost-bdfdb786.js');
require('axios');
require('md5');
require('./http-bb56b50d.js');
require('@mkt-common/shopee-common');
var historyApiConfig = function historyApiConfig(app, params) {
  return Boolean(app) ? {
    url: '/v1/message_history',
    method: history.HistoryApiMethod.POST,
    params: params
  } : {
    url: '/api/v2/user_message_history',
    method: history.HistoryApiMethod.GET,
    params: {
      params: params
    }
  };
};
var _a;
/** 获取接口相关配置 */
var getConfig = function getConfig(app, params) {
  return historyApiConfig(app, params);
};
/** 获取axios实例 */
var getRequest = function () {
  var request;
  return function (axiosConfig) {
    if (!request) {
      // CsChat baseURL 可能不同
      request = getSessionInfo.createRequest(getSessionInfo.__assign({
        baseURL: "https://" + getHost.getChatbotHost(),
        timeout: 10000
      }, axiosConfig));
      request.interceptors.request.use(function (config) {
        var region = getSessionInfo.getCSChatRegion();
        config.headers.common["shopee-region"] = getHost.COUNTRY;
        config.headers.common["user-region"] = region;
        // @ts-ignore
        config.requestStartTime = Date.now();
        return config;
      });
      request.interceptors.response.use(getSessionInfo.handleSuccess, getSessionInfo.handleError);
    }
    return request;
  };
}();
/** 获取历史消息 */
var getChatHistory = function getChatHistory(app, axiosConfig, params, fetchInjector) {
  return getSessionInfo.__awaiter(void 0, void 0, void 0, function () {
    var config, request, result;
    return getSessionInfo.__generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          // 拉取chat历史消息
          getSessionInfo.reportDebugLog('pull history message');
          config = getConfig(app, params);
          request = getRequest(axiosConfig);
          fetchInjector === null || fetchInjector === void 0 ? void 0 : fetchInjector(request);
          return [4 /*yield*/, request[config.method](config.url, config.params)];
        case 1:
          result = _a.sent();
          if (!(result instanceof Error)) {
            return [2 /*return*/, getSessionInfo.__assign(getSessionInfo.__assign({}, (result === null || result === void 0 ? void 0 : result.data) || {}), {
              messages: historyHandler(result.data.messages)
            })];
          }
          // 拉取chat历史消息失败
          getSessionInfo.reportErrorLog('pull history message error', {
            error: result
          });
          return [2 /*return*/, result];
      }
    });
  });
};
var inhouseHandler = function inhouseHandler(message // todoFormattedAgentContent | OriginInhouseContent
) {
  var content = message.content.content;
  var parseError = false;
  try {
    content = JSON.parse(content);
  } catch (e) {
    parseError = true;
  }
  return parseError ? getSessionInfo.__assign(getSessionInfo.__assign({}, message), {
    is_nonsupport: true
  }) : getSessionInfo.__assign(getSessionInfo.__assign({}, message), {
    content: getSessionInfo.__assign(getSessionInfo.__assign({}, message.content || {}), {
      content: content
    })
  });
};
var chatbotHandler = function chatbotHandler(message) {
  return getSessionInfo.__assign({}, message);
};
var txBotHandler = function txBotHandler(message // todo FormattedTxBotContent | OriginTxBotContent
) {
  var content = message.content.content;
  var parseError = false;
  try {
    content = JSON.parse(content);
  } catch (e) {
    parseError = true;
  }
  return parseError ? getSessionInfo.__assign(getSessionInfo.__assign({}, message), {
    is_nonsupport: true
  }) : getSessionInfo.__assign(getSessionInfo.__assign({}, message), {
    content: getSessionInfo.__assign(getSessionInfo.__assign({}, message.content || {}), {
      content: content
    })
  });
};
/** 历史消息处理 handler mapping */
var handlerMapping = (_a = {}, _a[history.HistoryMsgType.Inhouse] = inhouseHandler, _a[history.HistoryMsgType.Chatbot] = chatbotHandler, _a[history.HistoryMsgType.TxBot] = txBotHandler, _a[history.HistoryMsgType.CustomChatbot] = chatbotHandler, _a);
var historyHandler = function historyHandler(messages) {
  return messages.map(function (message) {
    if (!message.content || message.is_nonsupport) {
      return getSessionInfo.__assign(getSessionInfo.__assign({}, message), {
        is_nonsupport: true
      });
    }
    var handler = handlerMapping[message.msg_type];
    if (!handler) {
      return getSessionInfo.__assign(getSessionInfo.__assign({}, message), {
        is_nonsupport: true
      });
    }
    // @ts-ignore
    return handler(message);
  });
};
exports.getChatHistory = getChatHistory;